





















export default {
  props: {
    header: {
      default: "",
      type: String,
    },
    body: {
      default: "",
      type: String,
    },
    okText: {
      default: "ok",
      type: String,
    },
    
    onOk: {
      default: () => {},
      type: Function,
    },
   
    
    
     
  },
};
